var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114,
    height: 30,
    viewBox: "0 0 114 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3899 25.4049C11.1818 25.0185 1 29 1 29H113V1L105.873 4.42222H98.2364C94.899 6.94568 95.3181 6.94568 94.899 6.94568L93.0889 6.28889L83.0202 8.74321L70.1798 13.0988L64.3535 10.3333L60.1111 8.19012L53.9455 13.1333C53.9455 13.1333 50.3977 17.5041 48.6283 19.6667L42.7455 25.7506L35.8444 22.1556L29.7354 24.1605L23.4 26.5111L17.5172 26.0272L10.3899 25.4049Z",
    fill: "url(#paint0_linear_2027_110328)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 29C1 29 11.1818 25.0185 10.3899 25.4049L17.5172 26.0272L23.4 26.5111L29.7354 24.1605L35.8444 22.1556L42.7455 25.7506L48.6283 19.6667C50.3977 17.5041 53.9455 13.1333 53.9455 13.1333L60.1111 8.19012L64.3535 10.3333L70.1798 13.0988L83.0202 8.74321L93.0889 6.28889L94.899 6.94568C95.3181 6.94568 94.899 6.94568 98.2364 4.42222H105.873L113 1",
    stroke: "#10B981",
    strokeLinecap: "square"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2027_110328",
    x1: 57,
    y1: 1,
    x2: 55.8063,
    y2: 28.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ADE80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADE80",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.28063cb1.svg";
export { ForwardRef as ReactComponent };